(function () {
  const BTN_TEXTS = {
    1: {
      en: 'Add to Cart',
      it: 'Aggiungi al carrello',
      de: 'In den Warenkorb',
      fr: 'Ajouter au panier',
      es: 'Añadir al carrito'
    },
    2: {
      en: 'Buy now & get 1 free',
      it: 'Acquista ora e ricevi 1 gratis',
      de: 'Jetzt kaufen & 1 gratis erhalten',
      fr: 'Achetez maintenant & recevez 1 gratuit',
      es: 'Compra ahora y llévate 1 gratis'
    }
  };

  function getLang() {
    const lang = document.documentElement.lang || 'en';
    const code = lang.toLowerCase().split('-')[0];
    return ['en', 'it', 'de', 'fr', 'es'].includes(code) ? code : 'en';
  }

  function isDiscounted(comparePrice, price) {
    return Number(comparePrice) > 0 && Number(comparePrice) > Number(price);
  }

  function initBundlePicker(wrapper) {
    if (wrapper.dataset.dlBpInitialized === 'true') return;

    const productId = wrapper.dataset.productId;
    const data = window.DL_BP && window.DL_BP[productId];
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return;

    wrapper.dataset.dlBpInitialized = 'true';

    const freeShippingThreshold = data.freeShippingThreshold || 5000;
    const freeShippingLabel = data.freeShippingLabel || '+ Free shipping';
    const saveLabel = data.saveLabel || 'You save';

    let currentIndex = data.variants.length;

    const cards = wrapper.querySelectorAll('.dl-bp__card');
    const productInfo = wrapper.closest('product-info');
    const form = productInfo && productInfo.querySelector('product-form form');
    const variantInput = form && form.querySelector('input[name="id"]');

    function fmt(cents) {
      const amount = Number(cents) / 100;
      const format = data.moneyFormat || '{{amount_with_comma_separator}}';
      const fixed = amount.toFixed(2);
      const withComma = fixed.replace('.', ',');
      const noDecimals = Math.round(amount).toString();

      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, fixed);
    }

    function getVariantByIndex(index) {
      return data.variants.find(function (v) { return Number(v.index) === Number(index); });
    }

    function applySelectedClass() {
      cards.forEach(function (card) {
        card.classList.toggle('dl-bp__card--selected', Number(card.dataset.index) === currentIndex);
      });
    }

    function updateCards() {
      cards.forEach(function (card) {
        const index = Number(card.dataset.index);
        const variant = getVariantByIndex(index);
        if (!variant) return;

        const priceEl = card.querySelector('.dl-bp__price');
        const compareEl = card.querySelector('.dl-bp__compare');
        const offEl = card.querySelector('.dl-bp__off');
        const freeShippingEl = card.querySelector('.dl-bp__free-shipping');

        if (priceEl) priceEl.textContent = fmt(variant.price);

        if (compareEl) {
          if (isDiscounted(variant.compareAtPrice, variant.price)) {
            compareEl.textContent = fmt(variant.compareAtPrice);
            compareEl.classList.remove('dl-bp__hidden');
          } else {
            compareEl.textContent = '';
            compareEl.classList.add('dl-bp__hidden');
          }
        }

        if (offEl) {
          if (isDiscounted(variant.compareAtPrice, variant.price)) {
            const pct = Math.round(((variant.compareAtPrice - variant.price) * 100) / variant.compareAtPrice);
            offEl.textContent = pct + '% OFF';
            offEl.classList.remove('dl-bp__hidden');
          } else {
            offEl.textContent = '';
            offEl.classList.add('dl-bp__hidden');
          }
        }

        if (freeShippingEl) {
          if (Number(variant.price) >= freeShippingThreshold) {
            freeShippingEl.textContent = freeShippingLabel;
            freeShippingEl.classList.remove('dl-bp__hidden');
          } else {
            freeShippingEl.classList.add('dl-bp__hidden');
          }
        }
      });

      applySelectedClass();
    }

    function updateHeaderPrice(displayPrice, comparePrice) {
      if (!productInfo || !productInfo.dataset.section) return;
      const sectionId = productInfo.dataset.section;
      const priceWrapper = document.getElementById('price-' + sectionId);
      if (!priceWrapper) return;

      const currentPriceEl = priceWrapper.querySelector('.product-current-price');
      const oldPriceEl = priceWrapper.querySelector('.product-old-price');
      const savePillEl = priceWrapper.querySelector('.product-save-pill');
      const hasDiscount = isDiscounted(comparePrice, displayPrice);

      if (currentPriceEl) {
        currentPriceEl.textContent = fmt(displayPrice);
        currentPriceEl.style.color = hasDiscount ? '#D44C4D' : 'black';
      }

      if (oldPriceEl) {
        if (hasDiscount) {
          oldPriceEl.textContent = fmt(comparePrice);
          oldPriceEl.style.display = 'inline';
        } else {
          oldPriceEl.textContent = '';
          oldPriceEl.style.display = 'none';
        }
      }

      if (savePillEl) {
        if (hasDiscount) {
          savePillEl.textContent = saveLabel + ' ' + fmt(comparePrice - displayPrice);
          savePillEl.removeAttribute('hidden');
          savePillEl.classList.add('is-visible');
          savePillEl.style.removeProperty('visibility');
          savePillEl.style.removeProperty('opacity');
        } else {
          savePillEl.textContent = '';
          savePillEl.classList.remove('is-visible');
          savePillEl.setAttribute('hidden', 'hidden');
        }
      }
    }

    function updateMainMedia(variant) {
      if (!variant || !variant.featuredMediaId || !productInfo) return;
      const sectionId = productInfo.dataset.section;
      if (!sectionId) return;
      const mediaId = sectionId + '-' + variant.featuredMediaId;
      const mediaGallery = productInfo.querySelector('media-gallery') || document.querySelector('media-gallery');
      if (!mediaGallery) return;
      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(mediaId, true);
        return;
      }
      const btn =
        mediaGallery.querySelector('[data-target="' + mediaId + '"]') ||
        mediaGallery.querySelector('[aria-controls="' + mediaId + '"]') ||
        mediaGallery.querySelector('[data-media-id="' + mediaId + '"]') ||
        mediaGallery.querySelector('[data-target$="' + variant.featuredMediaId + '"]');
      if (btn) btn.click();
    }

    function updateButtonText() {
      const btn = productInfo && productInfo.querySelector('button[name="add"]:not([disabled])');
      if (!btn) return;
      const span = btn.querySelector('span:first-child');
      if (!span) return;
      const lang = getLang();
      const texts = BTN_TEXTS[currentIndex];
      if (!texts) return;
      span.textContent = texts[lang] || texts['en'];
    }

    function selectVariant(index) {
      const variant = getVariantByIndex(index);
      if (!variant) return;

      currentIndex = index;
      applySelectedClass();
      updateCards();

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.setAttribute('value', variant.id);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      setTimeout(function () {
        updateHeaderPrice(variant.price, variant.compareAtPrice);
        updateMainMedia(variant);
        updateButtonText();
        applySelectedClass();
      }, 300);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectVariant(Number(card.dataset.index));
      });
    });

    updateCards();
    selectVariant(currentIndex);
    updateButtonText();
  }

  function init() {
    document.querySelectorAll('.dl-bp').forEach(function (wrapper) {
      initBundlePicker(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();